/**
 * 事件消息处理 单例模式
 */

 import EVENT_MSG_TYPE from 'src/constant/event-msg-type';
import { win } from 'src/global';

type Handler = (events: any) => void | null;
interface EventMessage {
  events: IBaseEvent[],
  handler: Handler,
  publish<T>(event: IBaseEvent<T>): void,
  setHandler(hlder: Handler): void,
}
export interface IBaseEvent<T = any> {
  time: number,
  type: EVENT_MSG_TYPE,
  data: T,
  isManual?: boolean,
  [key: string]: unknown,
}

const eventMessage = win.__hb_eventMessage = (win.__hb_eventMessage || {
  events: [],
  handler: null,
  publish<T = any>(event: IBaseEvent<T>) {
    const events = eventMessage.events;
    events.push(event);
    // hbLogger.debug('publish', event.time, event.type);
    if(eventMessage.handler != null) {
      eventMessage.handler(events.splice(0));
    }
  },
  setHandler(hlder: Handler) {
    eventMessage.handler = hlder;
  }
}) as EventMessage;
export default eventMessage;

